import { siteRepo } from "@/repositories/siteRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useGetSite = (tenantId: string) => {
  return useObservable(() => siteRepo.get(tenantId), [tenantId]);
};
